var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sub-item",on:{"click":_vm.chooseItem}},[_c('i',{staticClass:"icon-choose"}),_vm._v(" "),_c('div',[_vm._v("单选题")])])}
var staticRenderFns = []
export { render, staticRenderFns }